import * as yup from 'yup';

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .min(2, 'Must be at least 2 characters long')
    .max(100, 'To long')
    .required('Name is required')
    .matches(/^[\p{L}\s'\-’]+$/u, 'Only letters and hyphens allowed'),
  email: yup
    .string()
    .email('Enter a valid email address')
    .required('Email is required')
    .matches(
      /^[a-zA-Z0-9_%+-][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Enter a valid email address',
    ),
  comments: yup.string().max(1000),
});
export default validationSchema;

// /^[A-Za-zА-Яа-яЁёІіЇїЄєҐґ'’\s-]+$/
